<template>
    <div
            class="columns delivery"
            :class="`delivery-3`"
    >
        <div class="column is-paddingless">
            <div class="columns is-mobile is-multiline delivery__main">
                <div class="column is-9 delivery__header-column">
                    <p class="is-size-5 is-marginless delivery__title">
                        <b><span class="delivery__green"> {{ complaint.name }} </span> , {{ complaint.address }}</b>
                    </p>
                </div>
                <div class="column delivery__header-column">
                    <p class="is-size-7 has-text-right">
                        {{ complaint.execution_date }}
                    </p>
                </div>
                <div class="column is-12">
                    <p class="delivery__text complaint__bottom_line">
                        {{complaint.message }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            complaint: {
                requred: true,
                type: Object

            }
        },
        created() {
            this.id = this._uid
            setInterval(() => {
                this.now = new Date()
            }, 1000)
        }
    }
</script>
<style lang="sass">
    @import "@/styles/variables"

    .complaint
        $this: &

        &__bottom_line
            border-bottom: 1px solid #3D3D3D
            padding-bottom: 5px
    .delivery
        $this: &

        &__icon
            margin-right: 0.25rem
            min-width: 1.2rem
            display: inline-block

        &__description
            font-weight: 300
            text-transform: uppercase

        &__complaints
            font-weight: 300
            color: $red

        &__title
            text-transform: uppercase

        &__green
            color: $green

        &__main
            background-color: $grey-light

        &__arrow
            padding-top: 0 !important
            display: flex

        &__button
            padding-left: 1rem
            padding-right: 1rem

        &__header-column
            padding-bottom: 0 !important

        &__info
            text-transform: uppercase
            font-weight: 300

        &__hr
            background-color: $grey
            height: 1px
            width: 100%
            margin: 0

        &__slide-wrapper
            overflow: hidden
            background-color: #fff

        &__text
            font-weight: 500
            margin-bottom: 0.75rem

        &__underline
            padding-bottom: 0.15rem
            border-bottom: 0.5px solid $green

        &__content
            padding-bottom: 1.25rem
            background-color: #fff

        &__image
            padding-top: 0 !important

            img
                width: 100%

        &__weight
            font-weight: 300

        &__amount
            font-weight: 600
            font-size: $size-5

        &__products
            list-style: none

        &__product_item
            display: inline

            &:not(:last-child)
                &::after
                    content: ","

</style>
